import { render, staticRenderFns } from "./create_student.vue?vue&type=template&id=ae827bc6&scoped=true"
import script from "./create_student.vue?vue&type=script&lang=js"
export * from "./create_student.vue?vue&type=script&lang=js"
import style0 from "./create_student.vue?vue&type=style&index=0&id=ae827bc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae827bc6",
  null
  
)

export default component.exports